import React, { useState } from 'react';

import Input from 'Components/Input';
import Button from 'Components/Button/Button';
import Icon from 'Components/Icon/Icon';

import useReducedErrors from 'Shared/hooks/useReducedErrors';

const SetNewPasswordView = ({
  formikProps: {
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    touched,
    values: { password, confirmPassword },
  },
}) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [confirmPasswordVisibility, setConfirmPasswordVisibility] = useState(false);
  const reducedErrors = useReducedErrors(errors);

  return (
    <form onSubmit={handleSubmit}>
      <h2 className="form__heading">Password reset</h2>
      <Input
        label="New password"
        helper={(touched.password && reducedErrors.password) || ''}
        helperVariant={touched.password && reducedErrors.password ? 'error' : 'message'}
        icon={
          <Icon
            name={passwordVisibility ? 'icon-visibility' : 'icon-invisible'}
            onClick={(e) => setPasswordVisibility(!passwordVisibility)}
          />
        }
        fieldProps={{
          name: 'password',
          type: passwordVisibility ? 'text' : 'password',
          value: password,
          placeholder: 'New password',
          onChange: handleChange('password'),
          onBlur: handleBlur('password'),
        }}
      />
      <Input
        label="Confirm password"
        helper={(touched.confirmPassword && reducedErrors.confirmPassword) || ''}
        helperVariant={touched.confirmPassword && reducedErrors.confirmPassword ? 'error' : 'message'}
        icon={
          <Icon
            name={confirmPasswordVisibility ? 'icon-visibility' : 'icon-invisible'}
            onClick={(e) => setConfirmPasswordVisibility(!confirmPasswordVisibility)}
          />
        }
        fieldProps={{
          name: 'confirmPassword',
          type: confirmPasswordVisibility ? 'text' : 'password',
          value: confirmPassword,
          placeholder: 'Confirm your new password',
          onChange: handleChange('confirmPassword'),
          onBlur: handleBlur('confirmPassword'),
        }}
      />
      <Button text="Change password" type="submit" size="block" />
    </form>
  );
};

export default SetNewPasswordView;
